import { render, staticRenderFns } from "./select-envelope-type.vue?vue&type=template&id=ea920866&scoped=true&"
import script from "./select-envelope-type.vue?vue&type=script&lang=js&"
export * from "./select-envelope-type.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea920866",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/brisk/brisk-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ea920866')) {
      api.createRecord('ea920866', component.options)
    } else {
      api.reload('ea920866', component.options)
    }
    module.hot.accept("./select-envelope-type.vue?vue&type=template&id=ea920866&scoped=true&", function () {
      api.rerender('ea920866', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/envelopes/partials/select-envelope-type.vue"
export default component.exports